import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex items-center mt-2 2xl:mt-0 2xl:justify-end justify-center flex-wrap" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessColorsLegend',
  setup(__props) {

const processTypes = ref<string[]>([
  "prefab",
  "support",
  "reinforce",
  "concrete",
  "sheath",
  "brickwork",
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processTypes.value, (processType) => {
      return (_openBlock(), _createElementBlock("div", {
        key: processType,
        class: "mx-1.5 text-sm align-middle"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(['w-3 h-3 mr-1 inline-block', `plannerProcessEvent_${processType}`])
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_ctx.$t(`report.sections.processes.process_type_entries.${processType}`)), 1)
      ]))
    }), 128))
  ]))
}
}

})